import React from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { FormattedMessage } from 'react-intl';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';

const LocalizedTitleField = ({ locale, object, ...props }) => {
  const propertyName = `title${locale?.toUpperCase().trim() || ''}`;
  return (
    <AvGroup className="form-label-group">
      <FormattedMessage id={propertyName}>
        {(placeholder) => (
          <AvInput
            id={object?.id || propertyName}
            type="text"
            name={propertyName}
            placeholder={placeholder}
            value={object ? object[propertyName] : ''}
            {...props}
          />
        )}
      </FormattedMessage>
      <Label for={object?.id || propertyName}>
        <FormattedMessage id={propertyName} />
      </Label>
    </AvGroup>
  );
};

LocalizedTitleField.propTypes = {
  locale: PropTypes.string,
  object: PropTypes.object,
};

export default LocalizedTitleField;
